import React, { useEffect, useState, useRef, useImperativeHandle, useContext, useMemo, useLayoutEffect } from 'react';
import { apiHolder, apiHolder as api, apis, isElectron, locationHelper, COPIED_ATTACH_KEY, } from 'api';
import UploadOutlined from '@ant-design/icons/UploadOutlined';
import { message, Modal, Button, Checkbox, Spin } from 'antd';
import { actions as mailTabActions } from '@web-common/state/reducer/mailTabReducer';
import { CollapsibleList } from '@web-common/components/UI/CollapsibleList';
import IconCard from '@web-common/components/UI/IconCard';
import classNames from 'classnames';
import dayjs from 'dayjs';
import DayViewTimeLineGrid from '@web-schedule/components/DayViewTimeLineGrid/DayViewTimeLineGrid';
import styles from './writePage.module.scss';
import WarnIcon from '@web-common/components/UI/Icons/svgs/WarnSvg';
import MailContent from './components/MailContent/MailContent';
import { TemplateEditor } from '@web-setting/Mail/components/CustomTemplate/template_editor';
import Prompt from '@web-mail-write/components/Prompt/prompt';
import WriteSide from './components/WriteContact/writeSide';
import MailInfo from './components/MailInfo/mailInfo';
import SendMail from './components/SendMail';
import MailFormat from './components/MailFormat/format';
import MailFormatModal from './components/MailFormat/modal';
import { InsertVariablModal } from '@web-edm/components/insertVariableOld/insertVariableModal';
import MailFormatEdit from './components/MailFormat/edit';
import { AppActions, MailActions, MailTemplateActions, useActions, useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { prePasteAttachment, preUploadAttachment } from './util';
import { currentMailSize as getCurrentMailSize } from '@web-common/state/getter';
import { AttachmentActions } from '@web-common/state/reducer';
import { TemplateListModal } from '@web-setting/Mail/components/CustomTemplate/template_list_modal';
import ErrorModal from '@web-mail-write/components/SendMail/ErrorModal';
import useState2SalesPitchReduxMock from '@/components/Layout/EnterpriseSetting/salesPitch/utils/useState2ReduxMock';
import { NewTamplateModal } from '@web-edm/mailTemplate/NewTamplateModal';
import { WriteContext } from '@web-setting/Mail/components/CustomTemplate/template_add_modal';
import useRightSideColumnStatusSelector from './hooks/useRightSideColunmStatusSelector';
import useConferenceSelector from './hooks/useConferenceSelector';
import useReceiverStateSelector from './hooks/useReceiverStateSelector';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import { SendValidateCompClone } from '@web-mail-write/components/SendMail/SendValidateComp';
import { getVariableSystemListAsync, getVariableListAsync } from '@web-common/state/reducer/configReudcer';
import { SaveDraftClone } from '@web-mail-write/components/SendMail/SaveDraft';
import { SaveAsTemplateCompClone } from '@web-mail-write/components/SendMail/SaveAsTemplateComp';
import CloseButton from '@web-mail-write/components/SendMail/CloseButton';
import Alert from '@web-common/components/UI/Alert/Alert';
import EmojiTip from './components/EmojiTip/emojiTip';
import debounce from 'lodash/debounce';
import AttUploading from '@web-mail-write/components/AttUploading/attUploading';
import { getIn18Text } from 'api';
import { SensitiveTip } from './components/MailContent/SensitiveTip';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import { useNiceModal } from '@web-common/components/UI/NiceModal/NiceModal';
import { SendProgress } from './components/MailContent/sendProgress';
import { FLOLDER } from '@web-mail/common/constant';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { ProductTip } from '@web-edm/send/ProductTip';
import SiteLinkButtonEntry from '@web-edm/components/SiteLinkButtonEntry';
import { contentAssitantEditor } from './components/MailContent/tools';
import DynGroupSend from './components/DynGroupSend/DynGroupSend';
import PreviewDyncGroup from './components/PreviewDyncGroup/PreviewDyncGroup';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const systemApi = apiHolder.api.getSystemApi();
const inElectron = systemApi.isElectron();
const DataStore = apiHolder.api.getDataStoreApi();
const StoreName = 'mfDialogTipState';
const FileApi = api.api.getFileApi();
const diskApi = apiHolder.api.requireLogicalApi(apis.netStorageImpl);
const storeApi = apiHolder.api.getDataStoreApi();
const eventApi = apiHolder.api.getEventApi();
const edmApi = apiHolder.api.requireLogicalApi(apis.edmSendBoxApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const templateType = 'write';
var EnumMfDialogState;
(function (EnumMfDialogState) {
    EnumMfDialogState["INIT"] = "INIT";
    EnumMfDialogState["STEP"] = "STEP";
    EnumMfDialogState["FINE"] = "FINE";
})(EnumMfDialogState || (EnumMfDialogState = {}));
const checkFilePaths = (filePaths) => {
    const checkPromises = filePaths.map(filePath => {
        return window.electronLib.fsManage.isDir(filePath);
    });
    return Promise.all(checkPromises)
        .then((resArr) => {
        const hasDir = resArr.some(isDir => {
            return isDir;
        });
        return {
            success: true,
            hasDir: hasDir,
            errorMsg: '',
        };
    })
        .catch(err => {
        return {
            success: false,
            hasDir: false,
            errorMsg: (err && err.message) || '未知原因',
        };
    });
};
const filePathToFile = (filePaths) => {
    const toPromises = filePaths.map(filePath => {
        return window.electronLib.fsManage
            .stat(filePath)
            .then((res) => {
            return {
                success: true,
                data: {
                    name: window.electronLib.fsManage.getBaseName(filePath),
                    size: res.size,
                    electronFullPath: filePath,
                },
            };
        })
            .catch((err) => {
            return {
                success: false,
                errorMsg: err && err.message,
            };
        });
    });
    return Promise.all(toPromises).then(files => {
        return files.filter((toRes) => {
            return toRes.success;
        });
    });
};
let hasHandleSendAttachments = false;
const WriteContentO = React.forwardRef((props, ref) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const { execAutoSaveDraft = false, innerCloseTab, style = {}, curMode = 'normal', setCurMode, cond } = props;
    const { isMailTemplate } = useContext(WriteContext);
    const [showWriteContact, showUserFreeBusy, sensitiveTipShow] = useRightSideColumnStatusSelector();
    const conferenceState = useConferenceSelector();
    const users = useReceiverStateSelector();
    const paidGuideModal = useNiceModal('paidGuide');
    const currentMail = useAppSelector(state => (isMailTemplate ? state.mailTemplateReducer.mailTemplateContent : state.mailReducer.currentMail));
    const currentMailRef = useRef(currentMail);
    currentMailRef.current = currentMail;
    const watchIdRef = useRef(null);
    const optSenderMainEmail = useMemo(() => currentMailRef.current.optSenderMainEmail, [currentMailRef.current]);
    const optSenderMainEmailRef = useRef(optSenderMainEmail);
    optSenderMainEmailRef.current = optSenderMainEmail;
    const curIdRef = useRef('');
    const senderReceivers = useAppSelector(state => state.mailReducer.currentMail.senderReceivers);
    const scheduleDate = useAppSelector(state => state.mailReducer.currentMail.scheduleDate);
    const mailEditStatus = useAppSelector(state => state.mailReducer.currentMail.mailEditStatus);
    const useVariable = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail.status) === null || _a === void 0 ? void 0 : _a.useVariable; });
    const isDyncGroupSend = useAppSelector(state => state.mailReducer.currentMail.isDyncGroupSend);
    const waittingMailIds = useAppSelector(state => state.mailReducer.waittingMailIds);
    const tooltipVisible = useAppSelector(state => state.mailReducer.tooltipVisible);
    const wirteMailSpin = useAppSelector(state => state.mailReducer.wirteMailSpin);
    const praiseMailShow = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail.status) === null || _a === void 0 ? void 0 : _a.praiseMailShow; });
    const taskMailShow = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail.status) === null || _a === void 0 ? void 0 : _a.taskMailShow; });
    const puretext = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail.status) === null || _a === void 0 ? void 0 : _a.puretext; });
    const dynGroupSendStatus = useAppSelector(state => { var _a, _b; return (_b = (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.dynGroupSendStatus; });
    const dyncGroupSendPreview = useAppSelector(state => state.mailReducer.dyncGroupSendPreview);
    const currentTab = useAppSelector(state => state.mailTabReducer.currentTab);
    const taskPraiseInfo = useRef({ praiseMailShow, taskMailShow });
    const puretextRef = useRef(!!puretext);
    const appActions = useActions(AppActions);
    const mailActions = useActions(MailActions);
    const [dialogTipState, setDialogTipState] = useState(EnumMfDialogState.FINE);
    const [mfModalState, setMfModalState] = useState(false);
    const [editState, setEditState] = useState(false);
    const [groupId, setGroupId] = useState('');
    const [mfId, setMfId] = useState('');
    const [sendLoading, setSendLoading] = useState(false);
    const [visibleConf, setVisibleConf] = useState(false);
    const [clickUploadAttach, setClickAttachment] = useState({
        clickUploadAttach: false,
        usingCloud: false,
    });
    const [clickMailFormat, setClickMailFormat] = useState(false);
    const [mailContentEdit, setMailContentEdit] = useState(null);
    const [scheduledSent, setScheduledSent] = useState(!!scheduleDate);
    const [readRemind, setReadRemind] = useState(!!senderReceivers);
    const [saveTime, setSaveTime] = useState('');
    const mailContentRef = useRef(null);
    const sendMailRef = useRef(null);
    const refDrag = useRef(null);
    const [dragging, setDragging] = useState(false);
    const [dragenterCount, setDragenterCount] = useState(0);
    const { doAddAttachment } = useActions(AttachmentActions);
    const currentMailId = useAppSelector(state => { var _a, _b; return (isMailTemplate ? (_a = state.mailTemplateReducer.mailTemplateContent) === null || _a === void 0 ? void 0 : _a.cid : (_b = state.mailReducer.currentMail) === null || _b === void 0 ? void 0 : _b.cid); });
    const attachments = useAppSelector(state => state.attachmentReducer.attachments);
    const currentMailSize = getCurrentMailSize(currentMail, attachments);
    const { doModifyReceiver, doModifySubject } = useActions(MailActions);
    const [variableInfo, setVariableInfo] = useState({ show: false });
    const [sendingProgressVisible, setSendingProgressVisible] = useState(false);
    const [composeId, setComposeId] = useState('');
    const subjectRef = useRef();
    const rightSideRef = useRef();
    const [sensitiveWords, setSensitiveWords] = useState([]);
    const [sensitiveWordsDetected, setSensitiveWordsDetected] = useState([]);
    const [sensitiveChecking, setSensitiveChecking] = useState(true);
    const [enableSensitiveMarks, setEnableSensitiveMarks] = useState(false);
    const [varListHeight, setVarListHeight] = useState(0);
    const [varListRealHeight, setVarListRealHeight] = useState(0);
    const [varListOpen, setVarListOpen] = useState(false);
    const varListRef = useRef(null);
    const varListContentRef = useRef(null);
    const varList = useMemo(() => {
        if (!dynGroupSendStatus)
            return [];
        const { variableArr, checkedList, insertTypes } = dynGroupSendStatus;
        if (!(variableArr === null || variableArr === void 0 ? void 0 : variableArr.length) || !(checkedList === null || checkedList === void 0 ? void 0 : checkedList.length) || !(insertTypes === null || insertTypes === void 0 ? void 0 : insertTypes.includes('text')))
            return [];
        const reg = /#{(.+?)}/;
        return variableArr
            .filter(item => checkedList.includes(item.var))
            .map(item => {
            const theVar = item.var;
            const execRes = reg.exec(theVar || '');
            return {
                name: item.key,
                enterName: item.value || item.key,
                value: execRes ? execRes[1] : theVar,
            };
        });
    }, [dynGroupSendStatus]);
    const showVarCont = useMemo(() => {
        var _a;
        return !!((_a = dynGroupSendStatus === null || dynGroupSendStatus === void 0 ? void 0 : dynGroupSendStatus.insertTypes) === null || _a === void 0 ? void 0 : _a.length);
    }, [dynGroupSendStatus]);
    useEffect(() => {
        if (process.env.BUILD_ISEDM) {
            dispatch(getVariableSystemListAsync());
            dispatch(getVariableListAsync());
        }
    }, []);
    useEffect(() => {
        if (process.env.BUILD_ISEDM) {
            edmApi.getSensitiveWords().then(data => {
                setSensitiveWords(data.sensitive_words);
            });
        }
    }, []);
    useEffect(() => {
        if (!process.env.BUILD_ISELECTRON && navigator) {
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            setIsSafari(isSafari);
        }
    }, []);
    const [isSafari, setIsSafari] = useState(false);
    const [toolbarHeight, setToolbarHeight] = useState(80);
    const [mailTemplateRemindVisible, setMailTemplateRemindVisible] = useState(false);
    const [insertRemindChecked, setInsertRemindChecked] = useState(false);
    const [isContentChanged, setIsContentChanged] = useState(false);
    const { changeShowTemplateList } = useActions(MailTemplateActions);
    const mailTemplate = useRef(null);
    const attachmentRef = useRef();
    const currentReceivers = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.receiver; });
    const currentSubject = useAppSelector(state => { var _a, _b; return (_b = (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.title; });
    const [productTipVisible, setProductTipVisible] = useState(false);
    const showProductModal = () => {
        var _a;
        (_a = mailContentRef.current) === null || _a === void 0 ? void 0 : _a.appendProductAction();
        setProductTipVisible(false);
    };
    const [siteLinkButtonVisible, setSiteLinkButtonVisible] = useState(false);
    const [siteLinkButtonPos, setSiteLinkButtonPos] = useState({ top: 0, left: 0 });
    const [rightSideColumnResizing, setRightSideColumnResizing] = useState(false);
    const [rightSideWidth, setRightSideWidth] = useState(200);
    const curModeRef = useRef(curMode);
    curModeRef.current = curMode;
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const [reminderVisible, setReminderVisible] = useState(false);
    const [cloudAttInfo, setCloudAttInfo] = useState();
    const [capturescreenTipVisible, setCapturescreenTipVisible] = useState(false);
    const [writePageSalesPitch, setWritePageSalesPitch] = useState2SalesPitchReduxMock('writePageSalesPitch');
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (writePageSalesPitch && writePageSalesPitch.discourseContent) {
            insertTemplateToEditor(writePageSalesPitch.discourseContent || '');
            setTimeout(() => {
                setWritePageSalesPitch(null);
            }, 1000);
        }
    }, [writePageSalesPitch === null || writePageSalesPitch === void 0 ? void 0 : writePageSalesPitch.discourseContent]);
    const spinText = useMemo(() => {
        const mailEditStatus = currentMail.mailEditStatus;
        if (mailEditStatus === 'reGenerating')
            return '因在写信时切换发信账号，邮件内容重新上传中，请稍候';
        if (mailEditStatus === 'reUploading')
            return '附件重传中，请稍等';
        return '';
    }, [currentMail]);
    const attUploadingShow = useMemo(() => {
        if (currentMailId && (waittingMailIds === null || waittingMailIds === void 0 ? void 0 : waittingMailIds.includes(currentMailId)))
            return true;
        return false;
    }, [waittingMailIds, currentMailId]);
    const setTooltipVisible = (vis) => {
        dispatch(mailActions.doSetTooltipVisible(vis));
    };
    useEffect(() => {
        taskPraiseInfo.current = { praiseMailShow, taskMailShow };
        puretextRef.current = !!puretext;
    }, [praiseMailShow, taskMailShow, puretext]);
    useEffect(() => {
        if (watchIdRef.current !== (currentMail === null || currentMail === void 0 ? void 0 : currentMail.cid))
            return;
        if ((currentMail === null || currentMail === void 0 ? void 0 : currentMail.cid) && waittingMailIds.includes(currentMail === null || currentMail === void 0 ? void 0 : currentMail.cid)) {
            dispatch(mailActions.doRemWaittingMailId(currentMail === null || currentMail === void 0 ? void 0 : currentMail.cid));
            message.error({ content: getIn18Text('ZIDONGFASONGZHONGD，QBJWCHCXFS') });
        }
    }, [
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.cid,
        (_a = currentMail === null || currentMail === void 0 ? void 0 : currentMail.status) === null || _a === void 0 ? void 0 : _a.cc,
        (_b = currentMail === null || currentMail === void 0 ? void 0 : currentMail.status) === null || _b === void 0 ? void 0 : _b.bcc,
        (_c = currentMail === null || currentMail === void 0 ? void 0 : currentMail.status) === null || _c === void 0 ? void 0 : _c.conferenceSetting,
        (_d = currentMail === null || currentMail === void 0 ? void 0 : currentMail.status) === null || _d === void 0 ? void 0 : _d.conferenceShow,
        (_e = currentMail === null || currentMail === void 0 ? void 0 : currentMail.status) === null || _e === void 0 ? void 0 : _e.praiseMailShow,
        (_f = currentMail === null || currentMail === void 0 ? void 0 : currentMail.status) === null || _f === void 0 ? void 0 : _f.praiseMailSetting,
        (_g = currentMail === null || currentMail === void 0 ? void 0 : currentMail.status) === null || _g === void 0 ? void 0 : _g.taskMailShow,
        (_h = currentMail === null || currentMail === void 0 ? void 0 : currentMail.status) === null || _h === void 0 ? void 0 : _h.puretext,
        (_j = currentMail === null || currentMail === void 0 ? void 0 : currentMail.status) === null || _j === void 0 ? void 0 : _j.taskMailSetting,
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.conference,
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.praiseMail,
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.taskMail,
        (_k = currentMail === null || currentMail === void 0 ? void 0 : currentMail.optSender) === null || _k === void 0 ? void 0 : _k.id,
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr,
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.subAccountExpired,
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.sender,
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.senders,
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.receiver,
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.isOneRcpt,
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.mailTrace,
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.senderReceivers,
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.requestReadReceipt,
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.scheduleDateTimeZone,
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.scheduleDate,
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.isEncryptedMail,
        currentMail === null || currentMail === void 0 ? void 0 : currentMail.savePassword,
        (_l = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _l === void 0 ? void 0 : _l.title,
        (_m = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _m === void 0 ? void 0 : _m.content,
        (_o = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _o === void 0 ? void 0 : _o.priority,
        (_p = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _p === void 0 ? void 0 : _p.encpwd,
    ]);
    const debounSetWatchId = debounce((cid) => {
        watchIdRef.current = cid;
    }, 500);
    useEffect(() => {
        debounSetWatchId(currentMail === null || currentMail === void 0 ? void 0 : currentMail.cid);
    }, [currentMail === null || currentMail === void 0 ? void 0 : currentMail.cid]);
    const addUploadAttachments = (files) => {
        var _a;
        const fileListAry = preUploadAttachment({ fileList: files, currentMailId, currentMailSize, cloudAttInfo });
        if (!fileListAry)
            return;
        doAddAttachment(fileListAry);
        (_a = attachmentRef === null || attachmentRef === void 0 ? void 0 : attachmentRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
        if (currentMail && currentMail.entry && currentMail.entry.title === '') {
            const firOne = fileListAry[0];
            const { fileName } = firOne;
            const name = fileName.split('.');
            name.length > 1 && name.pop();
            doModifySubject(name.join('.') || '');
        }
    };
    const handleSendFiles = (filePaths) => {
        checkFilePaths(filePaths).then(res => {
            if (res && res.success) {
                if (res.hasDir) {
                    Alert.info({
                        title: '文件检查错误',
                        content: '存在文件夹，请将文件夹压缩后重新添加',
                    });
                    return;
                }
                else {
                    filePathToFile(filePaths).then((sendFiles) => {
                        const files = sendFiles.filter(item => item.success).map(item => item.data);
                        if (currentMailId) {
                            addUploadAttachments(files);
                        }
                        else {
                            setTimeout(() => {
                                addUploadAttachments(files);
                            }, 1000);
                        }
                    });
                }
            }
            else {
                Alert.error({
                    title: '获取文件信息失败',
                    content: res.errorMsg,
                });
            }
        });
    };
    const pasteAtt = async () => {
        const res = await prePasteAttachment({
            currentMailSize,
            currentMail: currentMailRef.current,
        });
        if (!res)
            return;
        const { cid: curId, initSenderStr } = currentMailRef.current;
        const fromMailId = res.mailId;
        let file = Object.assign(Object.assign({}, res), { realId: mailApi.generateRndId(), partId: res.id, id: `${curId}_${fromMailId}_${res.id}_${Math.random()}`, fromMailId, mailId: currentMailRef.current.cid });
        const { cloudAttachment } = file;
        const _account = initSenderStr || '';
        if (cloudAttachment) {
            try {
                const dbStoreObj = Object.assign(Object.assign({}, file), { type: 'netfolder' });
                delete dbStoreObj['timestamp'];
                delete dbStoreObj['mailId'];
                delete dbStoreObj['file'];
                await mailApi.doSaveAttachmentToDB({
                    cid: curId,
                    _account: _account || '',
                    attachment: [dbStoreObj],
                });
                const reduxStoreObj = Object.assign(Object.assign({}, file), { mailId: curId, type: 'netUrl' });
                delete reduxStoreObj['timestamp'];
                dispatch(AttachmentActions.doAddAttachment([reduxStoreObj]));
                dispatch(mailActions.doChangeCacheAttachment({ id: curId, type: 'pasteCloud', value: dbStoreObj, operationType: 'add' }));
            }
            catch (error) {
                console.error('植入失败', error);
            }
            return;
        }
        else {
            const att = Object.assign(Object.assign({}, file), { type: 'waitNetUrl', attOpt: 'paste' });
            dispatch(AttachmentActions.doAddAttachment([att]));
        }
    };
    useEffect(() => {
        if (!process.env.BUILD_ISELECTRON)
            return;
        const isSendAttachmentPage = mailApi.getIsSendAttachmentWritePage();
        if (currentMailId && isSendAttachmentPage) {
            if (hasHandleSendAttachments) {
                return;
            }
            hasHandleSendAttachments = true;
            const storeKey = new URLSearchParams(location.search).get('store-key');
            if (storeKey) {
                mailApi.getStoreFilesByKey(storeKey).then(sendFilePaths => {
                    if (sendFilePaths && sendFilePaths.length) {
                        handleSendFiles(sendFilePaths);
                    }
                });
            }
        }
    }, [currentMailId, handleSendFiles]);
    useEffect(() => {
        setRightSideWidth(showWriteContact ? 200 : 360);
    }, [showWriteContact]);
    useEffect(() => {
        if (dialogTipState === EnumMfDialogState.FINE) {
            DataStore.get(StoreName).then(async (res) => {
                let state = res.data;
                if (!res.suc) {
                    DataStore.put(StoreName, EnumMfDialogState.INIT);
                    state = EnumMfDialogState.INIT;
                }
                setDialogTipState(state);
            });
        }
        return () => {
            if (!isMailTemplate) {
                if (isElectron() && locationHelper.testPathMatch('/writeMail')) {
                    appActions.doClearAllMails();
                    appActions.doFilterDownloadAttachment();
                }
            }
        };
    }, []);
    useEffect(() => {
        diskApi.doGetNSFolderInfo({ type: 'cloudAtt' }).then(res => {
            setCloudAttInfo(res);
        });
    }, []);
    const restRightSideState = () => {
        if (!showWriteContact) {
            mailActions.doShowWriteContact(true);
        }
        else {
            setRightSideWidth(200);
        }
    };
    useImperativeHandle(ref, () => ({
        forceSave: () => {
            var _a;
            return (_a = mailContentRef === null || mailContentRef === void 0 ? void 0 : mailContentRef.current) === null || _a === void 0 ? void 0 : _a.forceSave();
        },
        resetSideState: () => {
            restRightSideState();
        },
    }));
    const forceSave = () => { var _a; return (_a = mailContentRef === null || mailContentRef === void 0 ? void 0 : mailContentRef.current) === null || _a === void 0 ? void 0 : _a.forceSave(); };
    const insertTemplateToEditor = (content) => { var _a; return (_a = mailContentRef === null || mailContentRef === void 0 ? void 0 : mailContentRef.current) === null || _a === void 0 ? void 0 : _a.insertTemplateToEditor(content); };
    const handleNext = function () {
        if (dialogTipState === EnumMfDialogState.INIT) {
            DataStore.put(StoreName, EnumMfDialogState.STEP);
            setDialogTipState(EnumMfDialogState.STEP);
            return;
        }
        if (dialogTipState === EnumMfDialogState.STEP) {
            DataStore.put(StoreName, EnumMfDialogState.FINE);
            setDialogTipState(EnumMfDialogState.FINE);
        }
    };
    const showMfDialog = function () {
        setMfModalState(true);
    };
    const showMfEdit = function (groupId, mfId) {
        setGroupId(groupId);
        setMfId(mfId);
        setMfModalState(false);
        setEditState(true);
    };
    const getAutoSize = function (width, height) {
        if (width && height) {
            const max = inElectron ? 900 : 700;
            let autowidth = width;
            let autoHeight = height;
            const proportion = width / height;
            if (width > max) {
                autowidth = max;
                autoHeight = autowidth / proportion;
            }
            return [autowidth, autoHeight];
        }
        return [width, height];
    };
    const handleEditComplete = async (files) => {
        setSendLoading(true);
        for (let i = files.length - 1; i >= 0; i--) {
            const file = files[i];
            const { width, height } = file;
            const { type, size } = file.blob;
            const [autoWidth, autoHeight] = getAutoSize(width, height);
            const { data } = await FileApi.uploadFile({
                fileName: new Date().getTime() + type.includes('jpeg') ? '.jpg' : '.png',
                file: file.blob,
                fileSourceType: type,
                fileSize: size,
            });
            if (data && data.data && data.data.url) {
                const src = data.data.url;
                mailContentEdit.insertContent(`<p></p><img src="${src}" alt="" width="${autoWidth}" height="${autoHeight}" /></p></p>`);
            }
        }
        setTimeout(() => {
            setSendLoading(false);
        }, 1500);
    };
    const handleBack = () => {
        setSendLoading(false);
        setEditState(false);
        setMfModalState(true);
    };
    const uploadAttachmentAction = (uploadAttachment) => {
        setClickAttachment(uploadAttachment);
    };
    const mailFormatAction = () => {
        setClickMailFormat(true);
    };
    const handleMailEditCreated = ed => {
        setMailContentEdit(ed);
    };
    const uploadAttachmentRef = useRef(null);
    useEffect(() => {
        if (refDrag.current) {
            const node = refDrag.current;
            node.addEventListener('dragover', handleDragOver);
            node.addEventListener('dragenter', handleDragEnter);
            node.addEventListener('dragleave', handleDragLeave);
            return () => {
                node.removeEventListener('dragover', handleDragOver);
                node.removeEventListener('dragenter', handleDragEnter);
                node.removeEventListener('dragleave', handleDragLeave);
            };
        }
        return undefined;
    }, [refDrag.current]);
    const handleDragOver = e => {
        e.preventDefault();
        e.stopPropagation();
    };
    const handleDragEnter = e => {
        if ([...e.dataTransfer.items].every(i => i.kind !== 'file'))
            return;
        setDragenterCount(pre => pre + 1);
        setDragging(true);
        e.preventDefault();
        e.stopPropagation();
    };
    const handleDragLeave = e => {
        if ([...e.dataTransfer.items].every(i => i.kind !== 'file'))
            return;
        setDragenterCount(pre => {
            if (pre === 1)
                setDragging(false);
            return pre - 1;
        });
        e.preventDefault();
        e.stopPropagation();
    };
    const handleDragEnd = e => {
        if ([...e.dataTransfer.items].every(i => i.kind !== 'file'))
            return;
        setDragging(false);
        setDragenterCount(0);
        e.preventDefault();
        e.stopPropagation();
    };
    const handleDrop = async (e) => {
        var _a;
        if ([...e.dataTransfer.items].every(i => i.kind !== 'file'))
            return;
        e.preventDefault();
        e.stopPropagation();
        setDragging(false);
        setDragenterCount(0);
        const df = e.dataTransfer;
        let dropFiles = e.dataTransfer.files;
        trackApi.track('pcMail_dragFile_writeMailPage');
        if (df.items !== undefined) {
            dropFiles = [];
            for (let i = 0; i < df.items.length; i++) {
                const item = df.items[i];
                if (item.kind === 'file' && ((_a = item.webkitGetAsEntry()) === null || _a === void 0 ? void 0 : _a.isFile)) {
                    const file = item.getAsFile();
                    dropFiles.push(file);
                }
            }
            if (dropFiles.length !== e.dataTransfer.files.length) {
                message.error(getIn18Text('FUJIANBUZHICHI'));
            }
        }
        if (!dropFiles.length)
            return;
        addUploadAttachments(dropFiles);
    };
    const dropUpload = (error, fileList) => {
    };
    const insertMailInfoFromTemplate = (templateData) => {
        const receivers = templateData.receiver;
        if (receivers.length > 0) {
            const receiverTypes = receivers.reduce((total, current) => {
                const key = current.mailMemberType;
                if (!total[key]) {
                    total[key] = [];
                }
                return total;
            }, {});
            receivers.forEach(item => {
                const key = item.mailMemberType;
                receiverTypes[key].push(item);
            });
            Object.keys(receiverTypes).forEach((key) => {
                const currentReceiver = currentReceivers.filter(v => v.mailMemberType === key);
                const currentReceiverVal = currentReceiver.map(v => v.contactItem.contactItemVal);
                const receiver = receiverTypes[key].filter(v => !currentReceiverVal.includes(v.contactItem.contactItemVal));
                doModifyReceiver({ receiverType: key, receiver: [...currentReceiver, ...receiver] });
            });
        }
    };
    const insertSubjectFromTemplate = (templateData) => {
        if (!currentSubject) {
            doModifySubject(templateData.entry.title);
        }
    };
    const insertTemplate = () => {
        setMailTemplateRemindVisible(false);
        changeShowTemplateList({ isShow: false });
        const templateData = mailTemplate.current;
        if (templateData) {
            insertMailInfoFromTemplate(templateData);
            insertSubjectFromTemplate(templateData);
            insertTemplateToEditor(templateData.entry.content.content);
        }
    };
    const changeMailTempRemind = async (e) => {
        setInsertRemindChecked(e.target.checked);
        const val = e.target.checked ? '1' : '0';
        await DataStore.put('mailTemplateRemind', val);
    };
    const onRemindCancel = async () => {
        setMailTemplateRemindVisible(false);
        changeShowTemplateList({ isShow: true, templateType });
        await changeMailTempRemind({ target: { checked: false } });
    };
    const getTemplateResult = (data) => {
        mailTemplate.current = data;
        DataStore.get('mailTemplateRemind').then(v => {
            if (v.data === '1' || !isContentChanged) {
                insertTemplate();
            }
            else {
                setMailTemplateRemindVisible(true);
                changeShowTemplateList({ isShow: false });
            }
        });
    };
    const clickMailContent = e => {
        const { target } = e;
        if (target && mailContentEdit && target.isEqualNode(refDrag.current)) {
            mailContentEdit.focus();
        }
    };
    const updateSaveTime = () => {
        setSaveTime(dayjs().format('HH:mm'));
    };
    const webScale = () => {
        setCurMode && setCurMode(curModeRef.current === 'max' ? 'normal' : 'max');
    };
    const toggleContentAssistant = (isShow) => {
        if (curModeRef.current === 'max')
            return;
        dispatch(mailActions.doShowSensitiveTip(isShow));
    };
    const debounceSetReminderVisible = debounce(async () => {
        const riskReminderStatus = await storeApi.get('riskReminderStatus');
        const { data, suc } = riskReminderStatus;
        if (suc) {
            setReminderVisible(!!(data !== '1'));
        }
        else {
            setReminderVisible(true);
        }
    }, 300);
    useEffect(() => {
        setCurMode && setCurMode('normal');
        debounceSetReminderVisible();
        const { data, suc } = storeApi.getSync('lx_write_capturescreen1', { noneUserRelated: true });
        if (!suc || data !== 'true') {
            setCapturescreenTipVisible(true);
        }
        else {
            setCapturescreenTipVisible(false);
        }
    }, [currentMailId]);
    const subAccountLoginExpired = e => {
        const { eventData } = e;
        const { subAccount } = eventData;
        if (subAccount) {
            mailActions.doModifySubAccountExpired({ email: subAccount, expired: true });
        }
    };
    const freeUpgradeVersion = useCreateCallbackForEvent(e => {
        const { eventName, eventData } = e;
        if (eventName === 'upgradeVersion' && (eventData === null || eventData === void 0 ? void 0 : eventData.cid) === currentMailId) {
            paidGuideModal.show({ errType: '41', origin: '写信' });
        }
    });
    const insertVariableClick = async () => {
        const isSub = await accountApi.isSubAccount(optSenderMainEmail);
        if (isSub) {
            SiriusMessage.error({ content: getIn18Text('FEIZHUYOUXGZYXZBZCFS4') });
            return;
        }
        if (puretext) {
            SiriusMessage.error({
                content: `纯文本邮件暂不支持插入变量`,
            });
            return;
        }
        if (praiseMailShow || taskMailShow) {
            SiriusMessage.error({
                content: `${taskMailShow ? '任务' : '表扬'}邮件暂不支持插入变量`,
            });
            return;
        }
        setVariableInfo({
            show: true,
            source: 'subject',
        });
    };
    useEffect(() => {
        var _a, _b, _c, _d;
        if (!sensitiveTipShow && !showUserFreeBusy && !showWriteContact) {
            ((_a = rightSideRef === null || rightSideRef === void 0 ? void 0 : rightSideRef.current) === null || _a === void 0 ? void 0 : _a.controlAsideVisible) && ((_b = rightSideRef === null || rightSideRef === void 0 ? void 0 : rightSideRef.current) === null || _b === void 0 ? void 0 : _b.controlAsideVisible(false));
        }
        else {
            ((_c = rightSideRef === null || rightSideRef === void 0 ? void 0 : rightSideRef.current) === null || _c === void 0 ? void 0 : _c.controlAsideVisible) && ((_d = rightSideRef === null || rightSideRef === void 0 ? void 0 : rightSideRef.current) === null || _d === void 0 ? void 0 : _d.controlAsideVisible(true));
        }
        if (showUserFreeBusy || showWriteContact) {
            contentAssitantEditor(toggleContentAssistant, false);
        }
    }, [sensitiveTipShow, showUserFreeBusy, showWriteContact]);
    const onVaribleClickAction = async () => {
        var _a, _b, _c;
        const isSub = await accountApi.isSubAccount(optSenderMainEmailRef.current);
        if (isSub) {
            SiriusMessage.error({ content: getIn18Text('FEIZHUYOUXGZYXZBZCFS4') });
            return;
        }
        if (puretextRef.current) {
            SiriusMessage.error({
                content: `纯文本邮件暂不支持插入变量`,
            });
            return;
        }
        if (((_a = taskPraiseInfo.current) === null || _a === void 0 ? void 0 : _a.praiseMailShow) || ((_b = taskPraiseInfo.current) === null || _b === void 0 ? void 0 : _b.taskMailShow)) {
            SiriusMessage.error({
                content: `${((_c = taskPraiseInfo.current) === null || _c === void 0 ? void 0 : _c.taskMailShow) ? '任务' : '表扬'}邮件暂不支持插入变量`,
            });
            return;
        }
        setVariableInfo({
            show: true,
            source: 'content',
        });
    };
    const getEditor = () => {
        return mailContentRef === null || mailContentRef === void 0 ? void 0 : mailContentRef.current.getEditorInstance();
    };
    const reSelectVariables = () => {
        dispatch(MailActions.doChangeDyncGroupSendStatus({ showModal: true, step: 2 }));
    };
    const dyncGroupSendReset = () => {
        const dyncGroupSendId = (dynGroupSendStatus === null || dynGroupSendStatus === void 0 ? void 0 : dynGroupSendStatus.id) || '';
        const editor = getEditor();
        const curCont = editor.getContent();
        const parser = new DOMParser();
        const doc = parser.parseFromString(curCont, 'text/html');
        const table = doc.getElementById(`tabel_${dyncGroupSendId}`);
        table === null || table === void 0 ? void 0 : table.remove();
        const varEles = doc.querySelectorAll('.mce-lx-var');
        varEles.forEach(item => item.remove());
        const newCont = doc.body.innerHTML;
        editor.setContent(newCont);
        editor.fire('setPlaceHolder', { value: null });
        dispatch(mailActions.doChangeMailContent(newCont));
    };
    useEffect(() => {
        const eid = eventApi.registerSysEventObserver('upgradeVersion', { func: e => freeUpgradeVersion(e) });
        return () => {
            eventApi.unregisterSysEventObserver('upgradeVersion', eid);
        };
    }, []);
    useEffect(() => {
        const eid = eventApi.registerSysEventObserver('SubAccountLoginExpired', { func: e => subAccountLoginExpired(e) });
        return () => {
            eventApi.unregisterSysEventObserver('SubAccountLoginExpired', eid);
        };
    }, []);
    const checkAttCopied = () => {
        let pasteable = false;
        const { suc, data: copiedDataStr } = storeApi.getSync(COPIED_ATTACH_KEY);
        try {
            if (suc && copiedDataStr) {
                const copiedData = JSON.parse(copiedDataStr);
                const { timestamp } = copiedData;
                const formatStr = 'YYYY-MM-DD';
                const formatSaved = dayjs(timestamp).format(formatStr);
                const formatNow = dayjs().format(formatStr);
                if (formatSaved === formatNow)
                    pasteable = true;
            }
        }
        catch (error) {
            console.log('checkAttCopied error', error);
        }
        dispatch(MailActions.doUpdateAttPasteable(pasteable));
    };
    useEffect(() => {
        checkAttCopied();
    }, [currentMail === null || currentMail === void 0 ? void 0 : currentMail.cid, currentTab === null || currentTab === void 0 ? void 0 : currentTab.id]);
    useLayoutEffect(() => {
        let height = 0;
        if (showVarCont) {
            height = 44;
            if (varListOpen && varListRef.current && varListRef.current.scrollHeight) {
                height = varListRef.current.scrollHeight;
            }
        }
        setVarListHeight(height);
    }, [varListOpen, showVarCont]);
    useLayoutEffect(() => {
        let resizeObserver = new ResizeObserver(entries => {
            for (const entry of entries) {
                const height = entry.contentRect.height;
                setVarListRealHeight(height);
                if (varListOpen) {
                    setVarListHeight(height + 10);
                }
            }
        });
        if (showVarCont && varListContentRef.current) {
            resizeObserver.observe(varListContentRef.current);
        }
        return () => resizeObserver.disconnect();
    }, [showVarCont, varListOpen]);
    const turnVarClick = () => {
        setVarListOpen(i => !i);
    };
    const BelowOperateContent = (React.createElement(React.Fragment, null,
        React.createElement("div", { hidden: curMode === 'max', style: { flex: '0 0 auto' } },
            React.createElement(MailInfo, { visible: visibleConf, ref: subjectRef, setVisible: setVisibleConf, insertVariableClick: insertVariableClick, dyncGroupSendReset: dyncGroupSendReset, pasteAtt: pasteAtt })),
        isMailTemplate ? null : (React.createElement("div", { className: styles.operWrapper },
            React.createElement("div", { className: styles.operItem }),
            React.createElement("div", { className: styles.operItem },
                React.createElement(MailFormat, { clickMailFormat: clickMailFormat, setClickMailFormat: setClickMailFormat, showMfDialog: showMfDialog, dialogTipState: dialogTipState, handleNext: handleNext })))),
        React.createElement("div", { className: styles.writeMailEditorHeader + ' extheme class-for-imgproduct' + `${isSafari && isMailTemplate ? ' safari-add-mail-template' : ''}` },
            React.createElement("div", { className: styles.contentWrapper, id: "writeMailEditorScroll", style: {
                    marginTop: isSafari ? 0 : toolbarHeight + (varListHeight > 200 ? 200 : varListHeight),
                    paddingTop: isSafari ? toolbarHeight : 0,
                    height: `calc(100% - ${isSafari ? 0 : toolbarHeight + (varListHeight > 200 ? 200 : varListHeight)}px)`,
                } }, isMailTemplate ? (React.createElement(TemplateEditor, null)) : (React.createElement(React.Fragment, null,
                showVarCont && (React.createElement("div", { className: styles.varContainer, style: { height: varListHeight, top: toolbarHeight }, ref: varListRef },
                    React.createElement("div", { ref: varListContentRef, style: { height: 'fit-content' } },
                        React.createElement("span", { className: classNames(styles.varItem, styles.varSlectItem), onClick: reSelectVariables }, "\u91CD\u65B0\u9009\u62E9\u53D8\u91CF"),
                        varList.map(i => (React.createElement("span", { className: styles.varItem, onClick: () => { var _a; return (_a = mailContentRef.current) === null || _a === void 0 ? void 0 : _a.getEditorInstance().execCommand('appendVar', false, { key: i.value, value: i.enterName, nonSuffix: true }); } }, i.name)))),
                    varListRealHeight > 34 && (React.createElement("div", { className: styles.varTurn, onClick: turnVarClick },
                        varListOpen ? '收起' : '展开',
                        " ",
                        React.createElement(IconCard, { type: varListOpen ? 'upTriangle' : 'downTriangle' }))))),
                React.createElement(MailContent, { sensitiveChecking: process.env.BUILD_ISEDM && sensitiveChecking, enableSensitiveMarks: process.env.BUILD_ISEDM && enableSensitiveMarks, sensitiveWords: sensitiveWords, onVaribleClickAction: onVaribleClickAction, sensitiveWordsDetected: sensitiveWordsDetected, onSensitiveDetectedChange: setSensitiveWordsDetected, ref: mailContentRef, onEditCreated: handleMailEditCreated, mailFormatAction: mailFormatAction, uploadAttachmentAction: uploadAttachmentAction, onEditChange: () => setIsContentChanged(true), webScale: webScale, showAssistant: toggleContentAssistant, onToolbarHeightChange: setToolbarHeight, showProductTipActionFunc: () => setProductTipVisible(true), onSiteLinkButtonEntryClickFunc: (pos) => {
                        setSiteLinkButtonPos({ top: pos.top + 6, left: pos.left - 3 });
                        setSiteLinkButtonVisible(true);
                    }, setSiteLinkButtonVisible: setSiteLinkButtonVisible, pasteAtt: pasteAtt }),
                capturescreenTipVisible && inElectron && React.createElement(EmojiTip, { setCapturescreenTipVisible: setCapturescreenTipVisible })))),
            process.env.BUILD_ISEDM && !isMailTemplate && productTipVisible && (React.createElement(ProductTip, { onClose: () => setProductTipVisible(false), showProductModal: showProductModal, isMarketing: false })),
            process.env.BUILD_ISEDM && !isMailTemplate && (React.createElement(SiteLinkButtonEntry, { getContainer: "#mailboxModule", fromPage: "mail", visible: siteLinkButtonVisible, setVisible: setSiteLinkButtonVisible, pos: siteLinkButtonPos, mailInsertContent: (content) => {
                    insertTemplateToEditor(content);
                } }))),
        React.createElement("div", { className: styles.writeMailSpin, hidden: !wirteMailSpin },
            React.createElement(Spin, null)),
        isMailTemplate ? null : (React.createElement(SendMail, { ref: sendMailRef, execAutoSaveDraft: execAutoSaveDraft, sendLoading: sendLoading, setVisibleConf: setVisibleConf, editorInstance: mailContentEdit, forceSave: forceSave, isContentChanged: isContentChanged, tooltipVisible: tooltipVisible, setTooltipVisible: setTooltipVisible, readRemind: readRemind, setReadRemind: setReadRemind, saveTime: saveTime, setSaveTime: setSaveTime, updateSaveTime: updateSaveTime, innerCloseTab: innerCloseTab, scheduledSent: scheduledSent, setScheduledSent: setScheduledSent, onSendSuccess: (composeId, curId) => {
                if (composeId && composeId.length > 0) {
                    setComposeId(composeId);
                    setSendingProgressVisible(true);
                    curIdRef.current = curId || '';
                }
            } }))));
    const writeSideContent = (React.createElement(React.Fragment, null, React.createElement(CollapsibleList, { ref: rightSideRef, title: "\u4F1A\u8BAE\u5BA4\u5FD9\u95F2", needBtn: process.env.BUILD_ISEDM || (conferenceState && showUserFreeBusy), placement: "right", resizable: false, style: { zIndex: 100, height: '100%', width: '100%' }, defaultWidth: !sensitiveTipShow ? 360 : 220, minConstraints: [!sensitiveTipShow ? 360 : 220, Infinity], onOpen: () => {
        }, onClose: () => {
        }, innerStyle: { height: '100%' } },
        conferenceState && showUserFreeBusy && (React.createElement(DayViewTimeLineGrid, Object.assign({}, conferenceState, { users: users, sizeOptions: {
                GRID_CONTAINER_MARGIN_RIGHT: 0,
            } }))),
        showWriteContact && React.createElement(WriteSide, null),
        process.env.BUILD_ISEDM && !isMailTemplate && sensitiveTipShow && (React.createElement(SensitiveTip, { toolbarHeight: 0, insertContent: data => {
                if (data && data.trim()) {
                    insertTemplateToEditor(data);
                }
            }, setSensitiveChecking: setSensitiveChecking, setEnableSensitiveMarks: setEnableSensitiveMarks, sensitiveWordsDetected: sensitiveWordsDetected })))));
    const batchSucDealReducer = useCreateCallbackForEvent(async () => {
        currentMailId && dispatch(mailActions.doCloseMail(currentMailId));
        const { pathname } = window.location;
        if (process.env.BUILD_ISELECTRON && pathname.includes('/writeMail')) {
            setTimeout(() => {
                const isLowMemoryMode = systemApi.getIsLowMemoryModeSync();
                const isSendAttachmentPage = mailApi.getIsSendAttachmentWritePage();
                if (isLowMemoryMode || isSendAttachmentPage) {
                    window.electronLib.windowManage.getCurWindow().then((res) => {
                        const winId = res.id;
                        setTimeout(() => {
                            window.electronLib.windowManage.hide(winId);
                        }, 0);
                    });
                    setTimeout(() => {
                        systemApi.closeWindow();
                    }, 1200);
                }
                else {
                    systemApi.closeWindow();
                }
            }, 300);
            return;
        }
        dispatch(mailTabActions.doCloseTab(currentMailId));
    });
    const handleVariableChange = (value, name) => {
        var _a, _b;
        if (variableInfo.source === 'content') {
            (_a = mailContentRef.current) === null || _a === void 0 ? void 0 : _a.insertVariable(value, name);
        }
        else if (variableInfo.source === 'subject') {
            (_b = subjectRef.current) === null || _b === void 0 ? void 0 : _b.insertSubject(value, name);
        }
        dispatch(mailActions.doUseVariable(true));
        setVariableInfo({ show: false });
    };
    const VariableComp = () => {
        if (!variableInfo.show) {
            return undefined;
        }
        return (React.createElement(InsertVariablModal, { variableVisible: variableInfo.show, trackSource: 'unKnown', secondConfirm: true, hideCompanyVariable: true, onChange: handleVariableChange, defaultOpen: true, onVisible: visible => !visible && setVariableInfo({ show: false }) }));
    };
    return (React.createElement("div", { style: style, className: `${styles.mailWrapper} ${styles.writeContent} ${curMode === 'max' ? styles.max : ''} writePage-module-container` },
        React.createElement("div", { className: classNames(styles.mailBody, {
                [styles.mailBodyInResize]: rightSideColumnResizing,
            }) },
            attUploadingShow && React.createElement(AttUploading, null),
            process.env.BUILD_ISEDM ? React.createElement(NewTamplateModal, { emitResult: getTemplateResult, templateType: templateType }) : React.createElement(TemplateListModal, { emitResult: getTemplateResult }),
            React.createElement(Modal, { width: 400, visible: mailTemplateRemindVisible, maskClosable: false, onCancel: onRemindCancel, footer: null, closable: false },
                React.createElement("div", { className: styles.mailRemindContent },
                    React.createElement("div", { className: styles.mailRemindLeft },
                        React.createElement(WarnIcon, null)),
                    React.createElement("div", { className: styles.mailRemindRight },
                        React.createElement("p", { className: styles.mailRemindText }, getIn18Text('JIANCEDAOXIEXIN')),
                        React.createElement("div", { className: styles.mailRemindFooter },
                            React.createElement(Checkbox, { onChange: changeMailTempRemind, checked: insertRemindChecked }, getIn18Text('BUZAITIXING')),
                            React.createElement("div", { className: styles.mailRemindBtns },
                                React.createElement(Button, { style: { marginRight: '16px' }, onClick: onRemindCancel }, getIn18Text('QUXIAO')),
                                React.createElement(Button, { type: "primary", onClick: insertTemplate }, getIn18Text('QUEDINGCHARU'))))))),
            React.createElement("div", { className: styles.mailContent, onDrop: handleDragEnd, onClick: clickMailContent, ref: refDrag },
                !isMailTemplate && productVersionId === 'sirius' && reminderVisible && React.createElement(Prompt, null),
                !inElectron && !isMailTemplate && (React.createElement("div", { className: `ant-allow-dark ${styles.topOperate}` },
                    React.createElement("div", { style: { marginRight: '8px' } },
                        React.createElement(SendValidateCompClone, { sendLoading: sendLoading, tooltipVisible: tooltipVisible, scheduledSent: scheduledSent, readRemind: readRemind })),
                    React.createElement(SaveDraftClone, { tooltipVisible: tooltipVisible, sendLoading: sendLoading }),
                    React.createElement(SaveAsTemplateCompClone, { isContentChanged: !!isContentChanged }),
                    currentMailId && innerCloseTab && !inElectron && React.createElement(CloseButton, { id: currentMailId, innerCloseTab: innerCloseTab }))),
                inElectron ? BelowOperateContent : React.createElement("div", { className: styles.belowOperate }, BelowOperateContent),
                isMailTemplate ? null : (React.createElement("div", { className: `ant-allow-dark ${styles.attachmentDrop}`, onClick: () => {
                        setDragging(false);
                        setDragenterCount(0);
                    }, onDrop: handleDrop, hidden: !dragging },
                    React.createElement("p", { className: styles.dropUploadTips },
                        React.createElement(UploadOutlined, null),
                        React.createElement("span", { className: "text" }, getIn18Text('TIANJIAWEIFUJIAN'))))))),
        React.createElement("div", { className: styles.dividerLine }),
        process.env.BUILD_ISEDM && !isMailTemplate ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classNames(styles.contactWrapper, {
                    [styles.contactWrapperHidden]: curMode === 'max',
                    [styles.contactWrapperFreebusy]: !showWriteContact && showUserFreeBusy && !sensitiveTipShow,
                }) }, writeSideContent))) : (React.createElement("div", { className: classNames(styles.contactWrapper, {
                [styles.contactWrapperHidden]: curMode === 'max',
                [styles.contactWrapperFreebusy]: (!showWriteContact && showUserFreeBusy) || !sensitiveTipShow,
            }) }, writeSideContent)),
        React.createElement(MailFormatModal, { visible: mfModalState, showMfEdit: (groupId, mfId) => {
                showMfEdit(groupId, mfId);
            }, onCancel: () => setMfModalState(false) }),
        VariableComp(),
        editState ? (React.createElement(MailFormatEdit, { visible: editState, onCompleted: handleEditComplete, onCancel: () => {
                setEditState(false);
                setSendLoading(false);
            }, groupId: groupId, onBack: handleBack, mfId: mfId })) : (''),
        (useVariable || isDyncGroupSend) && sendingProgressVisible && (React.createElement(SendProgress, { composeId: composeId, visible: sendingProgressVisible, onBackToHomePage: () => {
                setSendingProgressVisible(false);
                batchSucDealReducer();
            }, onBackToSenderFolder: () => {
                setSendingProgressVisible(false);
                batchSucDealReducer();
                dispatch(mailTabActions.doChangeCurrentTab('-1/-1'));
                dispatch(mailActions.doUpdateSelectedKey({ id: FLOLDER.ALL_SENT }));
            } })),
        mailEditStatus && ['reGenerating', 'reUploading'].includes(mailEditStatus) && (React.createElement("div", { className: styles.spinningWrap },
            React.createElement(Spin, { spinning: true, tip: spinText }))),
        cond !== 'mailBox' && tooltipVisible && React.createElement(ErrorModal, { cond: cond }),
        React.createElement(DynGroupSend, { getEditor: getEditor, dyncGroupSendReset: dyncGroupSendReset }),
        (dyncGroupSendPreview === null || dyncGroupSendPreview === void 0 ? void 0 : dyncGroupSendPreview.show) && React.createElement(PreviewDyncGroup, null)));
});
export default WriteContentO;
